<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento') }}:
                |
                | {{ restricao.tile || restricao?.properties?.tile || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaGeometriaAnalisadaHa') }}:
                |
                | {{ restricao?.areaGeometriaAnalisadaHa ? Number(restricao.areaGeometriaAnalisadaHa).toFixed(2) : restricao?.properties?.areaGeometriaAnalisadaHa ? Number(restricao.properties.areaGeometriaAnalisadaHa).toFixed(2) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaTotalFeatureHa') }}:
                |
                | {{ restricao?.area_ha ? Number(restricao.area_ha).toFixed(2) : restricao?.properties?.area_ha ? Number(restricao.properties.area_ha).toFixed(2) : '-' }}
                br
</template>

<script>
export default {
    name: 'eudr_forest_cover_2020',

    data() {
        return {};
    },
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        }
    }
};
</script>
